import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { useUIStore } from '@/store/ui'

// Apply persisted theme before first paint.
if (useUIStore.getState().theme === 'dark') {
  document.documentElement.classList.add('dark')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
